import { Button, Checkbox, FormControl, FormControlLabel, InputLabel, Menu, MenuItem, Radio, RadioGroup, Select, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { Tune } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";


const radioStyles = {
  active: {
    color: 'green',
    '&.Mui-checked': {
      color: 'green',
    },
  },
  inactive: {
    color: 'red',
    '&.Mui-checked': {
      color: 'red',
    },
  },
  other: {
    color: 'blue',
    '&.Mui-checked': {
      color: 'blue',
    },
  },
};

const SubHeader = ({
  options = [],
  filter,
  menu,
  tabsData,
  isAvailable,
  isVisible,
  isFieldUser,
  setTabSearch,
  statusOptions,
  paymentOptions,
  setStatus,
  status,
  setPayStatus,
  paystatus,
  SortOptions,
  setSortStatus,
  sortstatus,
  selectedFilter,
  setSelectedFilter,
  filterOptions,
  filterdesigns,
  setFilterDesigns,
  fetchfilterdesigns,
  isOrderPage,
  onApplyFilter,
  anchorEl,
  open,
  handleClick,
  handleCloseFilter,
  handlesubApplyFilter,
  isSuborderPage,
  designkindoptins,
  design_kind,
  SetDesignType,
  fabricStatusOptions,
  SetFabricStatus,
  fabric_status,
  isPaymentPage,
  paymentfor,
  SetPaymentFor,
  paymentForoptions,
  handlePayApplyFilter,
  isConsultationPage,
  handleConsultApplyFilter,
  isUserpage,
  handleUserApplyFilter,
  userStatus,
  SetUserStatus,
  UserOptions,
  Consulationleftoptions,
  consultationLeft,
  SetConsultationLeft,
  Genderoptions,
  gender,
  SetGender,
  isEmployeepage,
  handleEmployeeApplyFilter,
  EmployeeRoleOptions,
  role,
  SetRole,
  isDesigntypepage,
  handleDesigntypeApplyFilter,
  handleDesignApplyFilter,
  isDesignpage,
  handleClearFilter

}) => {
  const [currentTabIndex, setCurrentTabIndex] = useState('');

  // Function to go to the tabs
  const handleTabChange = (event, newValue) => {
    setCurrentTabIndex(newValue);
    setTabSearch(newValue);
  };

  // const handleClose = () => {
  //   setAnchorEl(null);
  //   setTabSearch(''); // Clear the search input
  //   setCurrentTabIndex(''); // Clear the current tab index
  //   setStatus('');
  //   // setPayStatus('');
  //   // setSortStatus('');
  //   SetDesignType('');
  //   SetFabricStatus('');
  //   // SetPaymentFor('');
  //   // SetRole('');
  //   // SetUserStatus('');
  //   // SetConsultationLeft('');
  //   // SetGender('');
  //   // setSelectedFilter('');
  //   // setFilterDesigns('');
  // }

  return (
    <div className="catalogue-table">
      <div className="catalogue-menus" >
        <>
          {menu ? (
            <div className="tabs-title" >
              <Tabs value={currentTabIndex} onChange={handleTabChange}>
                {tabsData.map((tab, index) => (
                  <Tab key={index} value={tab.name} label={<div>{tab.label}</div>} />
                ))}
              </Tabs>
            </div>
          ) : null}
          <div className="filter-sort" style={{ marginLeft: filter ? 'auto' : '' }}>
            {filter ? (
              <div className="filter-container" >
                <div className="filter">
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    endIcon={<Tune />}
                    onClick={handleClick}
                  >
                    Filters
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                    onClose={handleCloseFilter}
                    className="filter-options"
                  >

                    <div className="filter-menu">
                      {isAvailable ? null : (
                        <>
                          {options.map((option, index) => (
                            <MenuItem key={index} >
                              {option}
                            </MenuItem>
                          ))}
                        </>
                      )}

                      {isVisible ? (
                        <div className="filter-fields">
                          <div className="header-main">
                            <Typography variant="body1">Filter</Typography>
                            <span onClick={handleCloseFilter}><ClearIcon /></span>
                          </div>
                          {statusOptions ? (
                            <div className="admin-textfiled">
                              <FormControl>
                                <InputLabel id="status-select-label">Status</InputLabel>
                                <Select
                                  labelId="status-select-label"
                                  id="status-select"
                                  value={status || ''}
                                  label='Status'
                                  onChange={(e) => {
                                    setStatus(e.target.value);
                                  }}
                                >
                                  {statusOptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}
                          {paymentOptions ? (
                            <div className="admin-textfiled" style={{ margin: "10px 0px" }}>
                              <FormControl >
                                <InputLabel id="payment-status-select-label">Payment Status</InputLabel>
                                <Select
                                  labelId="payment-status-select-label"
                                  id="payment-status-select"
                                  label='Payment Status'
                                  value={paystatus || ''}
                                  onChange={(e) => {
                                    setPayStatus(e.target.value);
                                  }}
                                >
                                  {paymentOptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}
                          {SortOptions ? (
                            <div className="admin-textfiled" >
                              <FormControl>
                                <InputLabel id="Sort-status-select-label">Sort By</InputLabel>
                                <Select
                                  labelId="Sort-status-select-label"
                                  id="Sort-status-select"
                                  label='Sort By'
                                  value={sortstatus || ''}
                                  onChange={(e) => {
                                    setSortStatus(e.target.value);
                                  }}
                                >
                                  {SortOptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}

                          {designkindoptins ? (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl>
                                <InputLabel id="designkind-select-label">Design Type</InputLabel>
                                <Select
                                  labelId="designkind-select-label"
                                  id="designkind-select"
                                  label='Design Type'
                                  value={design_kind}
                                  onChange={(e) => {
                                    SetDesignType(e.target.value);
                                  }}
                                >
                                  {designkindoptins.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}

                          {fabricStatusOptions ? (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl fullWidth >
                                <InputLabel id="fabric-status-select-label">Fabric Status</InputLabel>
                                <Select
                                  labelId="fabric-status-select-label"
                                  id="select-fabric-status"
                                  value={fabric_status}
                                  onChange={(e) => SetFabricStatus(e.target.value)}
                                  label="Fabric Status"
                                >
                                  {fabricStatusOptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}

                          {paymentForoptions ? (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl fullWidth >
                                <InputLabel id="payment-for-select-label">Payment For</InputLabel>
                                <Select
                                  labelId="payment-for-select-label"
                                  id="payment-for-select-label"
                                  value={paymentfor}
                                  onChange={(e) => SetPaymentFor(e.target.value)}
                                  label="Payment For"
                                >
                                  {paymentForoptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}

                          {EmployeeRoleOptions ? (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl fullWidth >
                                <InputLabel id="select-role-label">Select Role</InputLabel>
                                <Select
                                  labelId="select-role-label"
                                  id="select-role-label"
                                  value={role || ''}
                                  onChange={(e) => SetRole(e.target.value)}
                                  label="Select Role"
                                >
                                  {EmployeeRoleOptions.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}
                          {UserOptions && (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl>
                                <Typography className="status-text">User Status</Typography>

                                <RadioGroup
                                  aria-label="status"
                                  name="User Status"
                                  row
                                  className="radio-group"
                                  value={userStatus}   // userStatus will be "true" or "false"
                                  onChange={(e) => SetUserStatus(e.target.value)}
                                >
                                  {UserOptions.map((status, index) => (
                                    <FormControlLabel
                                      key={index}
                                      value={status === 'Active' ? 'true' : 'false'}
                                      control={
                                        <Radio
                                          sx={status === 'Active' ? radioStyles.active : radioStyles.inactive}
                                        />
                                      }
                                      label={
                                        <span
                                          className={status === 'Active' ? 'radio-active' : 'radio-inactive'}
                                        >
                                          {status}
                                        </span>
                                      }
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          )}


                          {Consulationleftoptions ? (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl>
                                <Typography className="status-text">Consultation Left Status</Typography>
                                <RadioGroup
                                  aria-label="Consultation Left Status"
                                  name="Consultation Left Status"
                                  row
                                  className="radio-group"
                                  value={consultationLeft}
                                  onChange={(e) => SetConsultationLeft(e.target.value)}
                                >
                                  {Consulationleftoptions.map((status, index) => (
                                    <FormControlLabel
                                      key={index}
                                      value={status === 'Yes' ? 'true' : 'false'}
                                      control={<Radio sx={status === 'Yes' ? radioStyles.active : radioStyles.inactive} />}
                                      label={<span className={status === 'Yes' ? 'radio-active' : 'radio-inactive'}>{status}</span>}
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          ) : null}

                          {Genderoptions && (
                            <div className="admin-textfiled" style={{ marginTop: "20px" }}>
                              <FormControl>
                                <Typography className="status-text">Gender</Typography>

                                <RadioGroup
                                  aria-label="Gender"
                                  name="Gender"
                                  row
                                  className="radio-group"
                                  value={gender}   // gender = "Male", "Female", or "Other"
                                  onChange={(e) => SetGender(e.target.value)}
                                >
                                  {Genderoptions.map((option, index) => (
                                    <FormControlLabel
                                      key={index}
                                      value={option}
                                      control={
                                        <Radio
                                          sx={
                                            option === 'Male'
                                              ? radioStyles.active
                                              : option === 'Female'
                                                ? radioStyles.inactive
                                                : radioStyles.other
                                          }
                                        />
                                      }
                                      label={
                                        <span
                                          className={
                                            option === 'Male'
                                              ? 'radio-active'
                                              : option === 'Female'
                                                ? 'radio-inactive'
                                                : 'radio-other'
                                          }
                                        >
                                          {option}
                                        </span>
                                      }
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          )}


                          {filterOptions ? (
                            <div className="admin-textfiled">
                              <FormControl fullWidth >
                                <InputLabel id="filter-select-label">Filter Design Type</InputLabel>
                                <Select
                                  labelId="filter-select-label"
                                  id="filter-select"
                                  value={selectedFilter}
                                  label="Filter Design Type"
                                  onChange={(e) => setSelectedFilter(e.target.value)}
                                >
                                  {filterOptions.map((option, index) => (
                                    <MenuItem key={index} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}
                          {fetchfilterdesigns ? (
                            <div className="admin-textfiled" >
                              <FormControl fullWidth>
                                <InputLabel id="filter-select-label">Filter Designs</InputLabel>
                                <Select
                                  labelId="filter-select-label"
                                  id="filter-select"
                                  value={filterdesigns}
                                  label="Filter Designs"
                                  onChange={(e) => setFilterDesigns(e.target.value)}
                                >
                                  {fetchfilterdesigns.map((option, index) => (
                                    <MenuItem key={index} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}
                          {isOrderPage && (
                            <Button className="apply-filter-btn" variant="contained" onClick={onApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {isSuborderPage && (
                            <Button className="apply-filter-btn" variant="contained" onClick={handlesubApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {isPaymentPage && (
                            <Button className="apply-filter-btn" variant="contained" onClick={handlePayApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {isConsultationPage && (
                            <Button className="apply-filter-btn" variant="contained" onClick={handleConsultApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {(isUserpage &&
                            <Button className="apply-filter-btn" variant="contained" onClick={handleUserApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {(isEmployeepage &&
                            <Button className="apply-filter-btn" variant="contained" onClick={handleEmployeeApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {(isDesigntypepage &&
                            <Button className="apply-filter-btn" variant="contained" onClick={handleDesigntypeApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          {(isDesignpage &&
                            <Button className="apply-filter-btn" variant="contained" onClick={handleDesignApplyFilter}>
                              Apply Filter
                            </Button>
                          )}
                          <Button className="apply-filter-btn" variant="contained" onClick={handleClearFilter}>
                            Reset
                          </Button>
                        </div>)
                        : null}
                    </div>
                  </Menu>
                </div>
              </div>
            ) : null}

          </div>
        </>
      </div >
    </div >
  );
};

export default SubHeader;


